import React from "react";
import Typography from "@mui/material/Typography";
import '../SbtierCSS/SbtierAboutUs.css';
import useDocumentMeta from "../hooks/useDocumentMeta";

const coreValues = [
    {
        tag: "// INNOVATION",
        title: "Innovation",
        text: "We are driven by a passion for solving complex problems with groundbreaking solutions. Our team constantly pushes the envelope to explore new ways to improve performance, reduce energy consumption, and enhance product reliability.",
    },
    {
        tag: "// EXCELLENCE",
        title: "Excellence",
        text: "Quality is the backbone of everything we do. From initial concept to final product, we ensure that every design, every chip, and every service we provide meets the highest standards of excellence.",
    },
    {
        tag: "// COLLABORATION",
        title: "Collaboration",
        text: "We believe that success comes from teamwork. Internally, we foster a culture of collaboration, where different perspectives drive creativity. Externally, we partner with customers and industry leaders.",
    },
    {
        tag: "// SUSTAINABILITY",
        title: "Sustainability",
        text: "As technology advances, so must our responsibility to the environment. We are dedicated to developing energy-efficient semiconductors that reduce environmental impact while still delivering superior performance.",
    },
];

function SbtierAbout(){
    useDocumentMeta(
        "About Us",
        "Meet SatyaBalTech Semiconductor (SBTS) — a startup team of chip design, embedded systems, and manufacturing experts building the next generation of semiconductor technology."
    );

    return(
        <div className="sbtier-about-container">
            {/*About us section*/}
            <section className="sbtierAbout-section" style={{backgroundImage: 'url("/images/about_us.png")'}}>
            <div className="hero-overlay" />
            <div className="hero-inner">
            <span className="hero-eyebrow">About SatyaBalTech</span>
            <Typography variant="h3" component="h3" className="welcome-title">
            About Us
            </Typography>
            <Typography variant="body1" className="welcome-text">
                At SatyaBalTech Semiconductor, we are a team of innovators, engineers, and visionaries dedicated
                to transforming the future of semiconductor technology. Founded with a passion for pushing
                the boundaries of what’s possible, we are committed to designing and delivering
                high-performance semiconductor solutions that meet the needs of tomorrow’s technologies.
            </Typography>
            </div>
            </section>

            {/** Who we are section */}
            <section className="sbtier-who-we-are-section">
            <div className="who-we-are-image">
                    <img src="images/about_us_who_what.webp" alt="who-we-are"/>
            </div>
                <div className="whoWeAre-content">
                    <Typography variant="h3" component="h3">
                        Who We Are
                    </Typography>
                    <Typography variant="body1" className="who-we-are-text">
                        We are a startup, but with big ambitions. Our diverse team brings together expertise in
                        chip design, system architecture, materials science, and manufacturing processes,
                        combined with fresh, innovative thinking that allows us to approach challenges
                        differently. We believe that innovation happens at the intersection of creativity and
                        precision, and we thrive in an environment where both are encouraged and celebrated.
                    </Typography>
                </div>
            </section>
            {/**sbtier what-we-do section */}
            <section className="sbtier-what-we-do-section">
                <div className="whatWeDo-content">
                <Typography variant="h3" component="h3">
                    What We Do
                </Typography>
                <Typography variant="body1" className="whatWeDo-text">
                    At the heart of our company is a commitment to building a team of experts to provide the
                    best solutions to all the semiconductor products that power the technologies of the
                    future. Whether it’s AI, IoT, automotive electronics, or next-generation computing,
                    we are focused on developing solutions that are faster, more efficient, and more
                    reliable. Our cutting-edge designs aim to meet the increasing demand for
                    high-performance and energy-efficient systems across various industries.
                </Typography>
                </div>
            </section>
        {/**sbtier core-values section */}
        <section className="sbtier-core-values-section">
            <Typography variant="h3" component="h3">
                Our Core Values
            </Typography>
            <div className="core-value-grid">
                <div className="core-value-image">
                    <img src="images/about_us_core_value.webp" alt="Our Core Value"/>
                </div>
                <div className="core-value-cards">
                    {coreValues.map((value) => (
                        <div className="core-value-card" key={value.title}>
                            <span className="core-value-tag">{value.tag}</span>
                            <h4>{value.title}</h4>
                            <p>{value.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
        {/**sbtier Exist section */}
        <section className="sbtier-exist-section">
            <div className="exist-content">
                <Typography variant="h3" component="h3">
                    Why We Exist
                </Typography>
                <Typography variant="body1" className="exist-text">
                    We started SatyaBalTech Semiconductor because we saw a gap in the industry—an opportunity to
                    bring fresh perspectives and agile development to the semiconductor space. With the rapid
                    advancement of technology and the demand for more integrated, intelligent systems, we knew
                    there was room for a company that could operate with the flexibility of a startup but with
                    the expertise and determination to tackle the big challenges.
                </Typography>
            </div>
        </section>
        {/**sbtier future-vision section */}
        <section className="sbtier-future-vision-section">
            <div className="future-vision-image">
                <img src="images/about_us_exist.webp" alt="future-vision"/>
            </div>
            <div className="future-vision-content">
                <Typography variant="h3" component="h3">
                Our Vision for the Future
                </Typography>
                <Typography variant="body1" className="future-vision-text">
                    We aim to become a leader in the semiconductor industry by driving innovation and shaping
                    the future of technology. Our goal is to develop solutions that enable the next
                    generation of technological advancements, from smart cities and autonomous vehicles to
                    sustainable energy solutions and advanced computing. With a focus on reliability,
                    efficiency, and innovation, we are here to power the future.
                </Typography>
            </div>
        </section>
        <section className="sbtier-statement-section">
            <p className="about-statement">
                At SatyaBalTech Semiconductor, we are just getting started. Join us as we push the limits of
                semiconductor technology and build a brighter future.
            </p>
        </section>
        </div>
    );
}

export default SbtierAbout;